import {PublicFlowEnum} from '../../constants/PublicFlowEnum';

const DEFAULT_STEPS: Record<PublicFlowEnum, number> = {
	[PublicFlowEnum.SIGN_UP]: 1,
	[PublicFlowEnum.FORGOT_PASSWORD]: 1,
};

export {DEFAULT_STEPS};
